
function ClearInput(form){
  
jQuery('html, body').animate({
    scrollTop: jQuery('#food-storage-calculator').offset().top - 80 
}, 500);
  
form.querySelector('#wheat').innerHTML="0";
form.querySelector('#flour').innerHTML="0";
form.querySelector('#cornmeal').innerHTML="0";
form.querySelector('#oats').innerHTML="0";
form.querySelector('#rice').innerHTML="0";
form.querySelector('#pasta').innerHTML="0";
form.querySelector('#sugar').innerHTML="0";
form.querySelector('#brown').innerHTML="0";
form.querySelector('#honey').innerHTML="0";
form.querySelector('#jello').innerHTML="0";
form.querySelector('#cornsyrup').innerHTML="0";
form.querySelector('#jams').innerHTML="0";
form.querySelector('#molasses').innerHTML="0";
form.querySelector('#fruitdrink').innerHTML="0";
form.querySelector('#milk').innerHTML="0";
form.querySelector('#evaporated').innerHTML="0";
form.querySelector('#other').innerHTML="0";
form.querySelector('#dairy').innerHTML="0";
form.querySelector('#oil').innerHTML="0";
form.querySelector('#fats').innerHTML="0";
form.querySelector('#shortening').innerHTML="0";
form.querySelector('#mayo').innerHTML="0";
form.querySelector('#dressing').innerHTML="0";
form.querySelector('#vinegar').innerHTML="0";
form.querySelector('#beans').innerHTML="0";
form.querySelector('#lentils').innerHTML="0";
form.querySelector('#split').innerHTML="0";
form.querySelector('#lima').innerHTML="0";
form.querySelector('#soy').innerHTML="";
form.querySelector('#drysoup').innerHTML="0";
form.querySelector('#peanut').innerHTML="0";
form.querySelector('#yeast').innerHTML="0";
form.querySelector('#soda').innerHTML="0";
form.querySelector('#powder').innerHTML="0";
form.querySelector('#salt').innerHTML="0";
form.querySelector('#water').innerHTML="0";
form.querySelector('#bleach').innerHTML="0";
form.querySelector('#grain').innerHTML="0";
form.querySelector('#sugars').innerHTML="0";
form.querySelector('#legumes').innerHTML="0";
form.children.value="0";
form.adult.value="0";

  
// form.querySelector('#corn').innerHTML="0";
// form.querySelector('#peas').innerHTML="0";
// form.querySelector('#greenbeans').innerHTML="0";
// form.querySelector('#carrots').innerHTML="0";
// form.querySelector('#potatoes').innerHTML="0";
// form.querySelector('#apples').innerHTML="0";
// form.querySelector('#applesauce').innerHTML="0";
// form.querySelector('#banana').innerHTML="0";
// form.querySelector('#fruitmix').innerHTML="0";
// form.querySelector('#fruitjuice').innerHTML="0";


  // form.querySelector('#apples').innerHTML = apples1 + apples4;
// form.querySelector('#applesauce').innerHTML = applesauce1 + applesauce4;
// form.querySelector('#banana').innerHTML = banana1 + banana4;
// form.querySelector('#fruitmix').innerHTML = fruitmix1 + fruitmix4;
// form.querySelector('#fruitjuice').innerHTML = fruitjuice1 + fruitjuice4;
// form.tfruits.value = ((apples1 + apples4 + applesauce1 + applesauce4 + banana1 + banana4 + fruitmix1 + fruitmix4 + fruitjuice1 + fruitjuice4)*1);
// form.querySelector('#corn').innerHTML = corn1 + corn4;
// form.querySelector('#peas').innerHTML = peas1 + peas4;
// form.querySelector('#greenbeans').innerHTML = greenbeans1 + greenbeans4;
// form.querySelector('#carrots').innerHTML = carrots1 + carrots4;
// form.querySelector('#potatoes').innerHTML = potatoes1 + potatoes4;
// form.querySelector('#onions').innerHTML = onions1 + onions4;
// form.querySelector('#tomatoes').innerHTML = tomatoes1 + tomatoes4;
// form.querySelector('#tveggies').innerHTML = ((corn1 + corn4 + peas1 + peas4 + greenbeans1 + greenbeans4 + carrots1 + carrots4 + potatoes1 + potatoes4 + onions1 + onions4 + tomatoes1 + tomatoes4)*1);
  
return true;
}


 
function SizeCalc(form){


duration = form.duration.value;
children = form.children.value * duration;
wheat1 = children * 8.33;
flour1 = children * 2.25;
cornmeal1 = children * 2.25;
oats1 = children * 2.25;
rice1 = children * 2.91;
pasta1 = children * 2.25;
beans1 = children * 1.66;
lima1 = children * 0.25;
soy1 = children * 0.42;
split1 = children * 0.25;
lentils1 = children * 0.25;
drysoup1 = children * 0.25;
oil1 = children * 0.08;
shortening1 = children * 0.17;
mayo1 = children * 0.08;
dressing1 = children * 0.08;
peanut1 = children * 0.17;
milk1 = children * 3.75;
evaporated1 = children * 0.66;
other1 = children * 0.66;
sugar1 = children * (20/12);
brown1 = children * (2/12);
molasses1 = children * (1/12);
honey1 = children * (2/12);
cornsyrup1 = children * (1/12);
jams1 = children * (2/12);
fruitdrink1 = children * (3/12);
jello1 = children * (1/12);
yeast1 = children * (1/12);
soda1 = children * (1/12);
powder1 = children * (1/12);
vinegar1 = children * (1/12);
salt1 = children * (3/12);
water1 = children * (92/12);
apples1 = children * 2.22;
applesauce1 = children * 2.22;
banana1 = children * 1.66;
fruitmix1 = children * 1.94;
fruitjuice1 = children * 2.22;
corn1 = children * 1.66;
peas1 = children * 1.66;
greenbeans1 = children * 1.66;
carrots1 = children * 1.66;
potatoes1 = children * 2.22;
onions1 = children * 0.27;
tomatoes1 = children * 1.11;




adult = form.adult.value * duration;
wheat4 = adult * 16.66;
flour4 = adult * 2.5;
cornmeal4 = adult * 2.5;
oats4 = adult * 2.5;
rice4 = adult * 5.83;
pasta4 = adult * 2.5;
beans4 = adult * 3.33;
lima4 = adult * 0.41;
soy4 = adult * 0.83;
split4 = adult * 0.41;
lentils4 = adult * 0.41;
drysoup4 = adult * 0.41;
oil4 = adult * 0.17;
shortening4 = adult * 0.33;
mayo4 = adult * 0.17;
dressing4 = adult * 0.08;
peanut4 = adult  * 0.33;
milk4 = adult * 6;
evaporated4 = adult * 1.25;
other4 = adult * 1.25;
sugar4 = adult * (40/12);
brown4 = adult * (3/12);
molasses4 = adult * (1/12);
honey4 = adult * (3/12);
cornsyrup4 = adult * (1/12);
jams4 = adult * (3/12);
fruitdrink4 = adult * (6/12);
jello4 = adult * (1/12);
yeast4 = adult * (1/12);
soda4 = adult * (1/12);
powder4 = adult * (1/12);
vinegar4 = adult * (1/12);
salt4 = adult * (5/12);
water4 = adult * (183/12);
apples4 = adult * 4.44;
applesauce4 = adult * 4.44;
banana4 = adult * 3.33;
fruitmix4 = adult * 35;
fruitjuice4 = adult * 4.44;
corn4 = adult * 3.33;
peas4 = adult * 3.33;
greenbeans4 = adult * 3.33;
carrots4 = adult * 3.33;
potatoes4 = adult * 4.44;
onions4 = adult * 0.55;
tomatoes4 = adult * 2.22;

form.querySelector('#dried_meats').innerHTML = Math.ceil((children*(10/12))+(adult*(20/12)));

form.querySelector('#wheat').innerHTML = Math.ceil(wheat1 + wheat4);
form.querySelector('#flour').innerHTML = Math.ceil(flour1 + flour4);
form.querySelector('#cornmeal').innerHTML = Math.ceil(cornmeal1 + cornmeal4);
form.querySelector('#oats').innerHTML = Math.ceil(oats1 + oats4);
form.querySelector('#rice').innerHTML = Math.ceil(rice1 + rice4);
form.querySelector('#pasta').innerHTML = Math.ceil(pasta1 + pasta4);
// form.querySelector('#grain').innerHTML = Math.ceil(wheat1 + wheat4 + flour1 + flour4 + cornmeal1 + cornmeal4 + oats1 + oats4 + rice1 + rice4 + pasta1 + pasta4);
form.querySelector('#grain').innerHTML = Math.ceil((children*(195/12))+(adult*(390/12)));
  
form.querySelector('#beans').innerHTML = Math.ceil(beans1 + beans4);
form.querySelector('#lima').innerHTML = Math.ceil(lima1 + lima4);
form.querySelector('#soy').innerHTML = Math.ceil(soy1 + soy4);
form.querySelector('#split').innerHTML = Math.ceil(split1 + split4);
form.querySelector('#lentils').innerHTML = Math.ceil(lentils1 + lentils4);
form.querySelector('#drysoup').innerHTML = Math.ceil(drysoup1 + drysoup4);
// form.querySelector('#legumes').innerHTML = Math.ceil(beans1 + beans4 + lima1 + lima4 + soy1 + soy4 + + split1 + split4 + lentils1 + lentils4 + drysoup1 + drysoup4);
form.querySelector('#legumes').innerHTML = Math.ceil((children*(35/12))+(adult*(70/12)));
form.querySelector('#oil').innerHTML = Math.ceil(oil1 + oil4);
form.querySelector('#shortening').innerHTML = Math.ceil(shortening1 + shortening4);
form.querySelector('#mayo').innerHTML = Math.ceil(mayo1 + mayo4);
form.querySelector('#dressing').innerHTML = Math.ceil(dressing1 + dressing4);
form.querySelector('#peanut').innerHTML = Math.ceil(peanut1 + peanut4);

  console.log(((oil1 + oil4)*7) + shortening1 + shortening4 + peanut1 + peanut4 + ((mayo1 + mayo4)*1) + ((dressing1 + dressing4)*1));
  
form.querySelector('#fats').innerHTML = Math.ceil(((oil1 + oil4)*7) + shortening1 + shortening4 + peanut1 + peanut4 + ((mayo1 + mayo4)*1) + ((dressing1 + dressing4)*1));
form.querySelector('#milk').innerHTML = Math.ceil(milk1 + milk4);
form.querySelector('#evaporated').innerHTML = Math.ceil(evaporated1 + evaporated4);
form.querySelector('#other').innerHTML = Math.ceil(other1 + other4);
// form.querySelector('#dairy').innerHTML = Math.ceil(milk1 + milk4 + ((adult * 2)+(children*1)) + other1 + other4);
form.querySelector('#dairy').innerHTML = Math.ceil((children*(44/12))+(adult*(87/12)));
form.querySelector('#sugar').innerHTML = Math.ceil(sugar1 + sugar4);
form.querySelector('#brown').innerHTML = Math.ceil(brown1 + brown4);
form.querySelector('#molasses').innerHTML = Math.ceil(molasses1 + molasses4);
form.querySelector('#honey').innerHTML = Math.ceil(honey1 + honey4);
form.querySelector('#cornsyrup').innerHTML = Math.ceil(cornsyrup1 + cornsyrup4);
form.querySelector('#jams').innerHTML = Math.round(jams1 + jams4);
form.querySelector('#fruitdrink').innerHTML = Math.round(fruitdrink1 + fruitdrink4);
form.querySelector('#jello').innerHTML = Math.round(jello1 + jello4);
form.querySelector('#sugars').innerHTML = Math.round(sugar1 + sugar4 + brown1 + brown4 + molasses1 + molasses4 + honey1 + honey4 + cornsyrup1 + cornsyrup4 + jams1 + jams4 + fruitdrink1 + fruitdrink4 + jello1 + jello4);
form.querySelector('#yeast').innerHTML = Math.round(yeast1 + yeast4);
form.querySelector('#soda').innerHTML = Math.ceil(soda1 + soda4);
form.querySelector('#powder').innerHTML = Math.ceil(powder1 + powder4);
form.querySelector('#vinegar').innerHTML = Math.ceil(vinegar1 + vinegar4);
form.querySelector('#salt').innerHTML = Math.ceil(salt1 + salt4);
form.querySelector('#water').innerHTML = Math.ceil(water1 + water4);
form.querySelector('#bleach').innerHTML = ((children*(0.5/12))+(adult*(1/12))).toFixed(1);

form.querySelector('#canned_fruits').innerHTML = Math.ceil((children*(160/12))+(adult*(320/12)));
  form.querySelector('#dried_fruits').innerHTML = Math.ceil((children*(45/12))+(adult*(90/12)));

// form.querySelector('#apples').innerHTML = apples1 + apples4;
// form.querySelector('#applesauce').innerHTML = applesauce1 + applesauce4;
// form.querySelector('#banana').innerHTML = banana1 + banana4;
// form.querySelector('#fruitmix').innerHTML = fruitmix1 + fruitmix4;
// form.querySelector('#fruitjuice').innerHTML = fruitjuice1 + fruitjuice4;
// form.tfruits.value = ((apples1 + apples4 + applesauce1 + applesauce4 + banana1 + banana4 + fruitmix1 + fruitmix4 + fruitjuice1 + fruitjuice4)*1);
// form.querySelector('#corn').innerHTML = corn1 + corn4;
// form.querySelector('#peas').innerHTML = peas1 + peas4;
// form.querySelector('#greenbeans').innerHTML = greenbeans1 + greenbeans4;
// form.querySelector('#carrots').innerHTML = carrots1 + carrots4;
// form.querySelector('#potatoes').innerHTML = potatoes1 + potatoes4;
// form.querySelector('#onions').innerHTML = onions1 + onions4;
// form.querySelector('#tomatoes').innerHTML = tomatoes1 + tomatoes4;
// form.querySelector('#tveggies').innerHTML = ((corn1 + corn4 + peas1 + peas4 + greenbeans1 + greenbeans4 + carrots1 + carrots4 + potatoes1 + potatoes4 + onions1 + onions4 + tomatoes1 + tomatoes4)*1);

jQuery('html, body').animate({
    scrollTop: jQuery('#foodResults').offset().top - 80 
}, 500);
  
return true;
}



jQuery(document).on('click', '.printResultBtn', function(e){
  e.preventDefault();
  window.print();
})